// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './premium-utilities.css';
import './darkTheme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './components/AuthContext';
import { SearchProvider } from '../src/context/searchContext';
import ErrorBoundary from './components/ErrorBoundary';
import { lockWindow } from './windowLock';
import { startErrorReporting } from './services/errorReporting';

// The window never stays scrolled on a computer (windowLock.js).
lockWindow();

// Env-gated and errors-only: no DSN (dev, self-hosters) means a silent
// no-op. Loaded as its own chunk, never in the main bundle
// (services/errorReporting.js).
startErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <SearchProvider>
          <App />
        </SearchProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
